import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/useUser'

const UserListItem = (props) => {
  const { user, user: { full_name, id } } = props

  const { editUserUrl } = generateUrls(user)

  const {
    agency, brand, provider, role,
  } = useRelations(user)

  const additionalSecondaryText = agency.title || brand.title || provider.title
    ? `| ${agency.title || brand.title || provider.title}`
    : ''

  return (
    <DashboardModuleListItem
      href={editUserUrl}
      secondaryText={`${role.title} ${additionalSecondaryText}`}
      title={full_name}
    >
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

UserListItem.propTypes = {
  user: PropTypes.object.isRequired,
}

export default UserListItem
